<template>
  <div class="index-module_articleWrap_2Zphx" style="text-indent:0;">
      <p class="zhemo">
          股票多因子量化概念白话解
        </p>
        <p  class="text_content">
          股票量化和期货量化虽然字面上都是量化，但实际上有着完全不同的交易理念。
        </p>
        <p class="text_content">
          期货量化模型，研究对象是某一具体的合约，管理的是买卖交易行为，通过挖掘数据找趋势规律确定买入卖出时机，来赚取买卖价差，属于择时交易的范畴。这个和期货合约的特点有关，大多的期货合约有效期一年，到期后无法继续持有，期货市场里中短期交易者居多。
        </p>
        <p class="text_content">
          股票量化模型，研究对象是全市场的3000多只股票，管理的是持仓股票池，综合利用财务数据、市场表现、基本面、技术面等各类因子，通过统计分析找出一些符合持有条件的股票，纳入到持仓股票池，长期持有，通过跟随股票增值来实现账户的净值增长，属于选股交易的范畴。持仓股票池是动态的，定期加入新股票和剔除旧股票。剔除一只股票不是因为这只股票大幅上涨而止盈，也不是因为这只股票大幅下跌而止损，而是因为这只股票不再符合持有条件。
        </p>
        <p class="text_content">
          从模型编写构成角度看，股票模型和期货模型最大的区别是股票模型只有一种条件：持有股票的条件，而期货模型有二种条件：买入的条件和卖出的条件。
        </p>
        <p class="text_content">
          wh5软件以价值投资理念为基础，提供专业的股票量化研究服务。提供300多个优选因子，可以检验因子有效性、分析因子相关性、合成综合因子作为选股条件，生成持仓股票池、策略分析报告和调仓列表。
        </p>
        <table border="0" cellpadding="0" cellspacing="0" class="list" name="table" id="table">
				<tbody>
					<tr class="header" >
						<td height="40"  bgcolor="#c86363" class="lLightBorder bBlackBorder rBlackBorder tLightBorder">分类</td>
						<td height="40"  bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">本质</td>
						<td height="40"  bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">判断依据</td>
						<td height="40"  bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">计算结果</td>
						<td height="40"  bgcolor="#c86363" class="bBlackBorder rBlackBorder tLightBorder">是否择时</td>
					</tr>
					<tr>
						<td height="40"  valign="middle" class="bLightBorder rLightBorder lLightBorder">
							期货量化
						</td>
						<td class="tableClass bLightBorder rLightBorder " >管理买卖行为</td>
						<td class="tableClass bLightBorder rLightBorder" >开平仓条件</td>
						<td class="tableClass bLightBorder rLightBorder" >买卖信号</td>
						<td  class=" bLightBorder rBlackBorder">是</td>
					</tr>
					<tr>
						<td height="40"  valign="middle" class="bLightBorder rLightBorder lLightBorder">
							股票量化
						</td>
						<td class="tableClass bLightBorder rLightBorder " >管理持仓股票池</td>
						<td class="tableClass bLightBorder rLightBorder" >多因子综合排名</td>
						<td class="tableClass bLightBorder rLightBorder" >调仓列表</td>
						<td  class=" bLightBorder rBlackBorder">否</td>
					</tr>

				</tbody>
			</table> 
            <p class="free">（原创）</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

  .service_content{
    width: 990px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 0 20px -5px #ccc; 
    min-height: 600px;
    padding-bottom: 50px;
  }
  .service_content .title{
    color: #5f5f5f;
    border-bottom: 1px dashed #a8a8a8;
    line-height: 40px;
    font-size: 22px;
  }
  .text_content{
    text-indent: 2em;
    font-size: 14px;
    line-height: 20px;
    color:#6f6f6f;
    padding: 10px 0;
    text-align: justify;
  }
  .title2{
    font-size: 16px;
    color: #5d0f0b;
    border-left: 4px solid #e24a49;
    font-weight: bold;
    padding-left: 10px;
    margin: 15px 0;
  }
  #table {
			width: 590px;
			margin: 20px auto;
            color: #6f6f6f;
            font-size: 15px;
            text-align: center !important;
		}
#table td{
line-height: 40px;

}
		/*第一种颜色*/
		#table tr.color1 {
			background-color: #FFFFFF;
		}

		/*第二种颜色*/
		#table tr.color2 {
			background-color: #F8F8F8;
		}

		#table td.teacher {
			background-color: #fff;
		}

		#table td.date {
			background-color: #F0F0F0;
		}

		#table td.time {
			background-color: #f8f8f8;
		}
		#table .header{
			color: #fff;
		}
		#table td.time p {
			margin: 0;
			padding: 0;
		}

		#table td span {
			/*margin-left:5px;*/
		}
		/* #table td {
			border-color: 1px solid #bfbfbf;
		} */
        .bBlackBorder {
			border-bottom: 1px solid #bfbfbf;
		}

		.rBlackBorder {
			border-right: 1px solid #bfbfbf;
		}

		.bGreyBorder {
			border-bottom: 1px solid #BFBFBF;
		}

		.rLightBorder {
			border-right: 1px solid #bfbfbf;
		}

		.bLightBorder {
			border-bottom: 1px solid #bfbfbf;
		}
		.tLightBorder{
			border-top: 1px solid #bfbfbf;
		}
		.lLightBorder{
			border-left: 1px solid #bfbfbf;
		}
</style>